import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetNamunaDataById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const NamunaFormReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    const res = await axios.get(getChildrenList)
    setStudents(res.data)
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(`${GetNamunaDataById}/${selectedStudent}`)
      setReportData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  const renderSection = (title, data, showValidDate = false) => {
    if (!data || data.length === 0) return null

    return (
      <div className="section">
        <p>
          <b>{title}</b>
        </p>

        {data.map((item, i) => (
          <div key={i} className="mb-3">
            <div className="row p-0 m-0">
              <div className="col-12 col-md-6">
                <p>
                  <b>अपलोड तारीख:</b> {item.uploaded_date}
                </p>
              </div>

              {showValidDate && (
                <div className="col-12 col-md-6">
                  <p>
                    <b>वैधता तारीख:</b> {item.valid_up_to_date}
                  </p>
                </div>
              )}
            </div>


            {item.upload_file ? (
              isPDF(item.upload_file) ? (
                <iframe
                  src={`${IMG_URL}${item.upload_file}`}
                  title="PDF Viewer"
                  className="pdf-viewer"
                />
              ) : (
                <img
                  src={`${IMG_URL}${item.upload_file}`}
                  className="doc-img"
                  alt="home-visit"
                />
              )
            ) : (
              <p>उपलब्ध नाही</p>
            )}
          </div>
        ))}
      </div>
    )
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">Namuna Report</h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : reportData ? (
            <div className="a4-page">
              {/* HEADER */}
              <div className="text-center pb-3">
                <h2>
                  <b>सेंट क्रिस्पिन्स होम</b>
                </h2>
                <h5>
                  <b>नमुना अहवाल</b>
                </h5>
              </div>

              {/* STUDENT */}
              <div className="section">
                <p>
                  <b>विद्यार्थ्याचे नाव:</b> {reportData.student_info}
                </p>
              </div>

              {/* ALL SECTIONS */}
              {renderSection('नमुना १८:', reportData.namuna_eighteens, true)}
              {renderSection('नमुना ४५:', reportData.namuna_fortyfives)}
              {renderSection('नमुना ९:', reportData.namuna_nines)}
              {renderSection('नमुना ७:', reportData.namuna_sevens)}
              {renderSection('नमुना २०:', reportData.namuna_twenties)}
              {renderSection('नमुना २२:', reportData.namuna_twentytwos)}
            </div>
          ) : (
            <p style={{ padding: 20 }}>No Data Found</p>
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          .row > div {
            padding: 2px !important;
          }
        }
      `}</style>
    </>
  )
}

export default NamunaFormReport
